var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { put, all, call } from 'redux-saga/effects';
import { requestExtraDataHandlerActionSaga } from '../../request-extra-data-handler-module';
import { redirectManagerSagaAction, } from '../../redirect-manager-module';
import { requestErrorHandlerProcess } from '../../../utils/request-error-handler-process';
import { getParsedError } from './_utils/get-parsed-error';
export function formManagerWorkerSaga(_a) {
    var _b, setModalAction, errorLoggerGlobal, responseData, formattedFormValues, formattedData_1, formErrors, redirectData, error_1, errorData_1, additionalErrors, formErrors, customModalTitle, params, logger, redirectData;
    var _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = _a.payload, resetInitialDataAction = _l.resetInitialDataAction, formValues = _l.formValues, formRequest = _l.formRequest, loadingStartAction = _l.loadingStartAction, loadingStopAction = _l.loadingStopAction, setErrorAction = _l.setErrorAction, setErrorActionsArray = _l.setErrorActionsArray, formSuccessAction = _l.formSuccessAction, formSuccessActionsArray = _l.formSuccessActionsArray, showNotification = _l.showNotification, callBackOnSuccess = _l.callBackOnSuccess, callBackOnError = _l.callBackOnError, requestExtraDataHandlerOptions = _l.requestExtraDataHandlerOptions, formValuesFormatter = _l.formValuesFormatter, responseDataFormatter = _l.responseDataFormatter, withoutFormattingError = _l.withoutFormattingError, redirectSuccessActionParams = _l.redirectSuccessActionParams, redirectErrorActionParams = _l.redirectErrorActionParams, formatDataToRedirectParamsSuccess = _l.formatDataToRedirectParamsSuccess, formatDataToRedirectParamsError = _l.formatDataToRedirectParamsError, requestErrorHandlerProcessParams = _l.requestErrorHandlerProcessParams, setFormExternalErrorsAction = _l.setFormExternalErrorsAction, textMessageSuccess = _l.textMessageSuccess, titleMessageSuccess = _l.titleMessageSuccess, getErrorModalActionTitle = _l.getErrorModalActionTitle, titleMessageError = _l.titleMessageError, scrollToErrorOnField = _l.scrollToErrorOnField, scrollFormErrorsFormatterOnSuccess = _l.scrollFormErrorsFormatterOnSuccess, scrollFormErrorsFormatterOnError = _l.scrollFormErrorsFormatterOnError, errorLogger = _l.errorLogger, store = _a.store, dispatch = _a.dispatch;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0:
                _b = (_c = store === null || store === void 0 ? void 0 : store.dependencies) !== null && _c !== void 0 ? _c : {}, setModalAction = _b.setModalAction, errorLoggerGlobal = _b.errorLoggerGlobal;
                if (!resetInitialDataAction) return [3 /*break*/, 2];
                return [4 /*yield*/, put(resetInitialDataAction(formValues))];
            case 1:
                _m.sent();
                _m.label = 2;
            case 2:
                if (!loadingStartAction) return [3 /*break*/, 4];
                return [4 /*yield*/, put(loadingStartAction())];
            case 3:
                _m.sent();
                _m.label = 4;
            case 4:
                formattedFormValues = formValuesFormatter
                    ? formValuesFormatter(formValues)
                    : formValues;
                _m.label = 5;
            case 5:
                _m.trys.push([5, 22, 35, 38]);
                if (!requestErrorHandlerProcessParams) return [3 /*break*/, 7];
                return [5 /*yield**/, __values(requestErrorHandlerProcess(__assign(__assign({}, requestErrorHandlerProcessParams), { request: function () {
                            return formRequest({
                                body: formattedFormValues,
                                isErrorTextStraightToOutput: Boolean(withoutFormattingError),
                            });
                        } })))];
            case 6:
                responseData = _m.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, call(formRequest, {
                    body: formattedFormValues,
                    isErrorTextStraightToOutput: Boolean(withoutFormattingError),
                })];
            case 8:
                // TODO FIX
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                responseData = _m.sent();
                _m.label = 9;
            case 9:
                if (responseData.error) {
                    // serialize data to be catched to the "catch" block and to be parsed
                    throw new Error(JSON.stringify({
                        errorText: responseData.errorText,
                        additionalErrors: responseData.additionalErrors,
                    }));
                }
                formattedData_1 = responseDataFormatter
                    ? responseDataFormatter(responseData.data)
                    : responseData.data;
                if (!callBackOnSuccess) return [3 /*break*/, 11];
                return [4 /*yield*/, callBackOnSuccess({ dispatch: dispatch, responseData: formattedData_1 })];
            case 10:
                _m.sent();
                _m.label = 11;
            case 11:
                if (!formSuccessAction) return [3 /*break*/, 13];
                return [4 /*yield*/, put(formSuccessAction(formattedData_1))];
            case 12:
                _m.sent();
                return [3 /*break*/, 15];
            case 13:
                if (!(formSuccessActionsArray && formSuccessActionsArray.length)) return [3 /*break*/, 15];
                return [4 /*yield*/, all(formSuccessActionsArray.map(function (successAction) {
                        return put(successAction(formattedData_1));
                    }))];
            case 14:
                _m.sent();
                _m.label = 15;
            case 15:
                if (!requestExtraDataHandlerOptions) return [3 /*break*/, 17];
                return [4 /*yield*/, put(requestExtraDataHandlerActionSaga({
                        data: formattedData_1,
                        options: requestExtraDataHandlerOptions,
                    }))];
            case 16:
                _m.sent();
                _m.label = 17;
            case 17:
                if (!(showNotification &&
                    (textMessageSuccess || titleMessageSuccess) &&
                    setModalAction)) return [3 /*break*/, 19];
                return [4 /*yield*/, put(setModalAction({
                        status: 'success',
                        title: titleMessageSuccess,
                        text: textMessageSuccess,
                    }))];
            case 18:
                _m.sent();
                _m.label = 19;
            case 19:
                // if scroll util and no redirect
                // to use simple responseData.data => "errors" field should be used
                if (scrollToErrorOnField && !redirectErrorActionParams) {
                    formErrors = (_f = (_d = scrollFormErrorsFormatterOnSuccess === null || scrollFormErrorsFormatterOnSuccess === void 0 ? void 0 : scrollFormErrorsFormatterOnSuccess(responseData.data)) !== null && _d !== void 0 ? _d : (_e = responseData.data) === null || _e === void 0 ? void 0 : _e.errors) !== null && _f !== void 0 ? _f : {};
                    scrollToErrorOnField({ formErrors: formErrors });
                }
                if (!redirectSuccessActionParams) return [3 /*break*/, 21];
                redirectData = formatDataToRedirectParamsSuccess
                    ? formatDataToRedirectParamsSuccess(__assign(__assign({}, redirectSuccessActionParams), formattedData_1))
                    : redirectSuccessActionParams;
                return [4 /*yield*/, put(redirectManagerSagaAction(redirectData))];
            case 20:
                _m.sent();
                _m.label = 21;
            case 21: return [3 /*break*/, 38];
            case 22:
                error_1 = _m.sent();
                console.error('formManagerWorkerSaga gets an error', error_1);
                errorData_1 = getParsedError({ sagaName: 'FormManagerSaga', error: error_1 });
                additionalErrors = (_h = (_g = errorData_1 === null || errorData_1 === void 0 ? void 0 : errorData_1.additionalErrors) === null || _g === void 0 ? void 0 : _g.errors) !== null && _h !== void 0 ? _h : null;
                if (!callBackOnError) return [3 /*break*/, 24];
                return [4 /*yield*/, callBackOnError({ errorData: errorData_1, dispatch: dispatch })];
            case 23:
                _m.sent();
                _m.label = 24;
            case 24:
                if (!setErrorAction) return [3 /*break*/, 26];
                return [4 /*yield*/, put(setErrorAction(errorData_1.errorText))];
            case 25:
                _m.sent();
                return [3 /*break*/, 28];
            case 26:
                if (!(setErrorActionsArray && setErrorActionsArray.length)) return [3 /*break*/, 28];
                return [4 /*yield*/, all(setErrorActionsArray.map(function (errorAction) {
                        return put(errorAction(errorData_1.errorText));
                    }))];
            case 27:
                _m.sent();
                _m.label = 28;
            case 28:
                // if scroll util and no redirect
                if (scrollToErrorOnField &&
                    !redirectErrorActionParams &&
                    (errorData_1 === null || errorData_1 === void 0 ? void 0 : errorData_1.errorText)) {
                    formErrors = (_k = (_j = scrollFormErrorsFormatterOnError === null || scrollFormErrorsFormatterOnError === void 0 ? void 0 : scrollFormErrorsFormatterOnError(errorData_1)) !== null && _j !== void 0 ? _j : additionalErrors) !== null && _k !== void 0 ? _k : {};
                    scrollToErrorOnField({ formErrors: formErrors });
                }
                if (!(setFormExternalErrorsAction && additionalErrors)) return [3 /*break*/, 30];
                return [4 /*yield*/, put(setFormExternalErrorsAction(additionalErrors))];
            case 29:
                _m.sent();
                _m.label = 30;
            case 30:
                if (!(showNotification && setModalAction)) return [3 /*break*/, 32];
                customModalTitle = titleMessageError || (getErrorModalActionTitle === null || getErrorModalActionTitle === void 0 ? void 0 : getErrorModalActionTitle(errorData_1.errorText));
                params = customModalTitle
                    ? {
                        status: 'error',
                        title: customModalTitle,
                        text: errorData_1.errorText,
                    }
                    : {
                        status: 'error',
                        text: errorData_1.errorText,
                    };
                return [4 /*yield*/, put(setModalAction(params))];
            case 31:
                _m.sent();
                _m.label = 32;
            case 32:
                if (errorLogger || errorLoggerGlobal) {
                    logger = errorLogger || errorLoggerGlobal;
                    logger({
                        error: error_1,
                        message: '[formManagerWorkerSaga]: get an error',
                    });
                }
                if (!redirectErrorActionParams) return [3 /*break*/, 34];
                redirectData = formatDataToRedirectParamsError
                    ? formatDataToRedirectParamsError(__assign(__assign({}, redirectErrorActionParams), additionalErrors))
                    : redirectErrorActionParams;
                return [4 /*yield*/, put(redirectManagerSagaAction(redirectData))];
            case 33:
                _m.sent();
                _m.label = 34;
            case 34: return [3 /*break*/, 38];
            case 35:
                if (!loadingStopAction) return [3 /*break*/, 37];
                return [4 /*yield*/, put(loadingStopAction())];
            case 36:
                _m.sent();
                _m.label = 37;
            case 37: return [7 /*endfinally*/];
            case 38: return [2 /*return*/];
        }
    });
}
